import type { ForwardedRef } from 'react';

import { Image, Link, Text } from '@change/ds-core-ui/next';

import { forwardRef } from '@change-corgi/core/react/core';
import { Translate } from '@change-corgi/core/react/i18n';

import type { NewsAndGuidesListItem } from 'src/app/pages/newsAndGuides/list/pageContext';
import { useItemCard } from 'src/app/pages/newsAndGuides/list/shared/hooks';
import { LegacyHtml as Html } from 'src/app/shared/components/html';

type Props = {
	item: NewsAndGuidesListItem;
};

export function FeaturedCardInner({ item }: Props, ref: ForwardedRef<HTMLDivElement>) {
	const {
		data: { categoryName, targetUrl, photoUrl },
	} = useItemCard(item);

	return (
		<div className="relative h-auto w-full pt-0 md:h-[310px] md:pt-6 lg:h-[360px] lg:pt-10" ref={ref}>
			<div className="static right-0 top-0 block h-60 w-full md:absolute md:h-full md:w-[65%] lg:w-[60%]">
				<Image
					src={photoUrl}
					fallback={
						<Image
							src="https://static.change.org/images/default-petition.gif"
							alt=""
							className="h-full w-full rounded-small object-cover"
							loading="lazy"
							role="presentation"
						/>
					}
					alt=""
					className="h-full w-full rounded-small object-cover"
					loading="lazy"
					role="presentation"
				/>
			</div>

			<div className="bg-fill-inverse-strong static w-full rounded-small py-6 pl-2 pr-2 md:relative md:w-[66%] md:pl-0 md:pr-[30px]">
				<Text as="span" fontWeight="bold" size="x-small" className="text-typography-weak uppercase">
					{categoryName}
				</Text>
				<Text as="h2" variant="heading" size="small" className="my-2">
					{item.title}
				</Text>
				<Html as="div" html={item.excerpt} breakWord lineClamp={[null, 3]} />
				<Link href={targetUrl} className="mt-2" data-qa="card-read-more-link">
					<Translate value="fe.pages.news_index.read_more" />
				</Link>
			</div>
		</div>
	);
}

export const FeaturedCard = forwardRef(FeaturedCardInner);
